import script from "./FileEditPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileEditPopup.vue?vue&type=script&setup=true&lang=ts"

import "./FileEditPopup.vue?vue&type=style&index=0&id=47a1327d&scoped=true&lang=scss"

import exportComponent from "C:\\repos\\1File_WebClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47a1327d"]])

export default __exports__